var _path, _path2, _path3, _g, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.668 171.52H21.332C9.559 171.52 0 181.078 0 192.852V448c0 35.285 28.715 64 64 64h384c35.285 0 64-28.715 64-64V192.852c0-11.774-9.559-21.332-21.332-21.332zm0 0",
    fill: "#eceff1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M448 64H64C28.652 64 0 92.652 0 128v64.852h512V128c0-35.348-28.652-64-64-64zm0 0",
    fill: "#2196f3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 0h-21.332C94.891 0 85.332 9.559 85.332 21.332v85.336c0 11.773 9.559 21.332 21.336 21.332H128c11.777 0 21.332-9.559 21.332-21.332V21.332C149.332 9.559 139.777 0 128 0zm0 0M405.332 0H384c-11.777 0-21.332 9.559-21.332 21.332v85.336c0 11.773 9.555 21.332 21.332 21.332h21.332c11.777 0 21.336-9.559 21.336-21.332V21.332C426.668 9.559 417.109 0 405.332 0zm0 0",
    fill: "#1976d2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2196f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.332 234.668H80c-8.832 0-16 7.168-16 16V304c0 8.832 7.168 16 16 16h53.332c8.832 0 16-7.168 16-16v-53.332c0-8.832-7.168-16-16-16zm0 0M133.332 362.668H80c-8.832 0-16 7.168-16 16V432c0 8.832 7.168 16 16 16h53.332c8.832 0 16-7.168 16-16v-53.332c0-8.832-7.168-16-16-16zm0 0M282.668 234.668h-53.336c-8.832 0-16 7.168-16 16V304c0 8.832 7.168 16 16 16h53.336c8.832 0 16-7.168 16-16v-53.332c0-8.832-7.168-16-16-16zm0 0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.668 362.668h-53.336c-8.832 0-16 7.168-16 16V432c0 8.832 7.168 16 16 16h53.336c8.832 0 16-7.168 16-16v-53.332c0-8.832-7.168-16-16-16zm0 0",
    fill: "#90caf9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M432 234.668h-53.332c-8.832 0-16 7.168-16 16V304c0 8.832 7.168 16 16 16H432c8.832 0 16-7.168 16-16v-53.332c0-8.832-7.168-16-16-16zm0 0",
    fill: "#2196f3"
  })));
}

export default __webpack_public_path__ + "655727955222bd153164fb9d689da222.svg";
export { SvgCalendar as ReactComponent };